import classNames from "classnames";
import * as React from "react";

import styles from "./Badge.module.css";

export type BadgeVariant =
  "primary" | "secondary" | "success" | "warning" | "error" | "info" | "brand";

export interface BadgeProps {
  /** What the label means, as a color. Defaults to `primary`. */
  variant?: BadgeVariant;
  /** Drawn before the label. */
  icon?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

/**
 * A small filled label for a status or a category. It only reads: a label
 * that can be clicked or removed is a `Tag`.
 */
export function Badge({
  variant = "primary",
  icon,
  className,
  children,
}: BadgeProps) {
  return (
    <span
      className={classNames(styles.badge, className)}
      data-variant={variant}
    >
      {icon}
      {children}
    </span>
  );
}
